import { useId } from "react";

interface Props {
  data: number[];
  color?: string;
  fill?: boolean;
  height?: number;
  strokeWidth?: number;
  max?: number;
  min?: number;
}

export function Sparkline({
  data,
  color = "var(--cyan)",
  fill = true,
  height = 28,
  strokeWidth = 1.5,
  max,
  min,
}: Props) {
  const rawId = useId();
  const id = `sp-${rawId.replace(/:/g, "")}`;

  if (!data || data.length === 0) {
    return (
      <svg className="spark" viewBox="0 0 100 28" preserveAspectRatio="none" />
    );
  }
  const w = 100;
  const h = height;
  const dmin = min ?? Math.min(...data);
  const dmax = max ?? Math.max(...data);
  const range = dmax - dmin || 1;
  const step = w / (data.length - 1 || 1);
  const pts = data.map((v, i) => [i * step, h - ((v - dmin) / range) * (h - 2) - 1] as const);
  const line = pts
    .map((p, i) => `${i === 0 ? "M" : "L"}${p[0].toFixed(2)},${p[1].toFixed(2)}`)
    .join(" ");
  const area = `${line} L${w},${h} L0,${h} Z`;
  return (
    <svg className="spark" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" style={{ height }}>
      <defs>
        <linearGradient id={id} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      {fill && <path d={area} fill={`url(#${id})`} />}
      <path
        d={line}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
